import SimpleAccordion from '../../../Core/Expansion/SimpleAccordion'
import React, { useState,useContext } from 'react'
import FlexView from 'react-flexview'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { ReactComponent as AICircle } from '../../../../assets/ai.svg';
import { ReactComponent as PersonCircle } from '../../../../assets/person_with_circle.svg';
import { Dialog,FormControlLabel,Radio,Divider } from '@material-ui/core';
import CircledPopUpFrame from '../../../Core/CircledPopUpFrame';
import { isMobile } from 'react-device-detect';
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService';
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog';
import { useLocation } from 'react-router-dom';
import DataLayerService from '../../../../services/DataLayerService';
import PolicyLiabilityExtensionContext, { PolicyLiabilityExtensionContextStore, ACTIONS } from '../../../../context/PolicyLiabilityExtensionContext'
import {ModificationContextStore} from '../../../../context/ModificationContext'
import { billingPeriodPretty, liabilityLimitPretty } from '../../../../services/utils'
import { PolicyEquipmentView } from '../../../Core/Hull/PolicyEquipmentView'
import { PersonalInjuryPopover } from '../../../Core/Popover/PersonalInjuryPopover'
import { FirebaseService, FirebaseConfigKey } from '../../../../services/FirebaseService';
import { MedicalExpensesPopover } from '../../../Core/Popover/MedicalExpensesPopover'
import { SessionContextStore } from '../../../../context/SessionContext';
import { SessionService } from "../../../../services/SessionService";

var classNames = require('classnames')


interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel
}


export const ModifyAdditionalCoverages = ({...props}: PolicyAdditionalInsuredSectionProps) => {
    const location = useLocation()
    const liabilityExtensionContext = useContext(PolicyLiabilityExtensionContextStore)
    const modificationContext = React.useContext(ModificationContextStore) 
    const sessionContext = React.useContext(SessionContextStore)
    const {insurance,modificationObject,isRenewal} = props;

    const changePersonalInjuryLimit = (e) =>{
        modificationContext.setPersonalInjuryLimit(e.target.value,isRenewal)
    }

    return (
    <React.Fragment>
       <SimpleAccordion className="margin-top-large" title={
       <FlexView column className="space-between full-width"> <div>Additional Coverages <PersonalInjuryPopover /></div>
            <div className="grey text-small">Personal and Advertising Injury Coverage (Including Privacy), Medical Expense</div>
       </FlexView>} 
            content={
                <div>
                    <FlexView vAlignContent={'center'} className="margin-bottom-6">
                        <div className="text-body bold black">Personal and Advertising Injury Coverage (Including Privacy)</div>
                        <PersonalInjuryPopover />
                    </FlexView>
                    {FirebaseService.getArray(FirebaseConfigKey.PERSONAL_INJURY_COVERAGE).filter((personalInj, index) => personalInj >= insurance.personalInjuryLimit || (SessionService.isAdmin() || isRenewal)).map((personalInj, index) => <FormControlLabel 
                                key={index}
                                label={`${FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}${personalInj.toLocaleString()} ${index == 0 ? ' (Included)' : ''}`} 
                                onChange={changePersonalInjuryLimit}
                                checked={modificationObject.personalInjuryLimit == personalInj}
                                value={personalInj} control={<Radio className={classNames({'gray': index == 0})}
                                color="primary" />} />)}
                    
                    <Divider />
                </div>
                }/>
                
    </React.Fragment>)
}